// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cafd29b4","453":"51b20bab","732":"26c71b40","977":"ee2477a9"}[chunkId] + ".chunk.js";
};